import React from "react";
import { useTranslation } from "react-i18next";
import styled, { createGlobalStyle } from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Header, { NavLink, NavLinks } from "components/headers/light";
import Footer from "components/footers/MiniCenteredFooter";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import { provider, policyVersion, servicePolicies } from "content/servicePolicies";

const Article = styled.article`
  ${tw`max-w-screen-md mx-auto text-gray-800 leading-relaxed`}
  h1 { ${tw`text-3xl md:text-4xl font-black mb-4`} }
  h2 { ${tw`text-xl md:text-2xl font-bold mt-10 mb-4`} }
  p { ${tw`my-4`} }
  a { ${tw`text-primary-500 underline`} }
  @media print {
    button { display: none; }
  }
`;
const Provider = tw.div`bg-gray-100 rounded-lg p-6 my-8 text-sm leading-loose`;
const Actions = tw.div`flex gap-4 flex-wrap mb-8 text-sm`;
const PrintButton = tw.button`px-4 py-2 rounded bg-primary-500 text-white font-semibold`;
const PrintStyles = createGlobalStyle`
  @media print {
    header, footer, [data-contact-widget], #fb-root, #fb-customer-chat { display: none !important; }
    .App { padding: 0 !important; overflow: visible !important; }
    article { max-width: none !important; color: black !important; }
    article section { break-inside: avoid; }
  }
`;

export default function ServicePolicyPage({ type }) {
  const { i18n } = useTranslation();
  const [language, setLanguage] = React.useState(i18n.language?.startsWith("vi") ? "vi" : "en");
  const labels = servicePolicies[language];
  const policy = labels[type];
  const links = [
    <NavLinks key="policy">
      <NavLink href="/">{labels.home}</NavLink>
      <NavLink href="/terms">{labels.termsLabel}</NavLink>
      <NavLink href="/privacy">{labels.privacyLabel}</NavLink>
    </NavLinks>,
  ];

  return (
    <AnimationRevealPage disabled>
      <PrintStyles />
      <Header links={links} />
      <Container>
        <ContentWithPaddingXl>
          <Article lang={language} data-policy-version={policyVersion}>
            <Actions>
              <button onClick={() => setLanguage("vi")} aria-pressed={language === "vi"}>Tiếng Việt</button>
              <button onClick={() => setLanguage("en")} aria-pressed={language === "en"}>English</button>
              <PrintButton onClick={() => window.print()}>{labels.print}</PrintButton>
            </Actions>
            <h1>{policy.title}</h1>
            <p>{policy.intro}</p>
            <Provider>
              <strong>{provider.name} / {provider.internationalName}</strong><br />
              {labels.taxLabel}: {provider.taxId}<br />
              {provider.address}<br />
              <a href={`mailto:${provider.email}`}>{provider.email}</a>
            </Provider>
            {policy.sections.map((section) => (
              <section key={section.title}>
                <h2>{section.title}</h2>
                {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              </section>
            ))}
            <Actions>
              <a href="/terms">{labels.termsLabel}</a>
              <a href="/privacy">{labels.privacyLabel}</a>
              <a href="/">{labels.home}</a>
            </Actions>
          </Article>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}
